import { getSymbol, theme } from "@xola/ui-kit";
import React, { ComponentProps } from "react";
import { useSeller } from "../../hooks/useAccount";
import { FormatInput } from "./FormatInput";
import { useLocalizationStore } from "@/stores/localizationStore";

export const CurrencyInput = (props: ComponentProps<typeof FormatInput>) => {
    const seller = useSeller();
    const locale = useLocalizationStore().getLocale();

    const timezone = seller.timezoneName;
    const currency = getSymbol(seller.currency, locale);

    // Check if the seller's timezone is in Japan
    const isJapaneseSeller = timezone.includes("Japan") || timezone.includes("Tokyo");
    // Set decimalScale to 0 for Japanese sellers, otherwise use the default (2)
    const decimalScale = isJapaneseSeller ? 0 : 2;

    const prefixColors = {
        background: theme.colors.gray.lighter,
        border: theme.colors.secondary.light,
    };

    const style = props.isStyled
        ? { boxShadow: `inset ${prefixColors.background} 40px 0 0 -1ex, inset ${prefixColors.border} 41px 0 0 -1ex` }
        : {};

    const prefix = props.isStyled ? `${currency}     ` : `${currency}  `;

    return <FormatInput style={style} decimalScale={decimalScale} prefix={prefix} {...props} />;
};
